import { forwardRef, PropsWithChildren } from 'react'

import { Variant } from '~/src/components/generic/IconButton/types'
import {
  classVariantsV2,
  disabledClassVariants,
} from '~/src/components/generic/IconButton/constants'
import Spinner from '~/src/components/generic/Spinner'

import { tw } from '~/lib/utils'

type Props = {
  variant: Variant
  loading?: boolean
  className?: string
  disabled?: boolean
  onClick?: () => void
}

const IconButton = forwardRef<HTMLButtonElement, PropsWithChildren<Props>>(
  ({ className, loading, variant, disabled, children, onClick, ...props }, ref) => (
    <button
      className={tw(
        'flex cursor-pointer items-center justify-center rounded-full',
        classVariantsV2[variant],
        disabled ? disabledClassVariants[variant] : '',
        className
      )}
      disabled={disabled}
      ref={ref}
      onClick={onClick}
      {...props}
    >
      <div className={loading ? 'invisible' : 'visible'}>{children}</div>
      <div
        className={tw(
          'absolute left-0 top-0 h-full w-full items-center justify-center',
          loading ? 'flex' : 'hidden'
        )}
        data-testid="spinner"
      >
        <Spinner color="#fff" size={32} />
      </div>
    </button>
  )
)

IconButton.displayName = 'IconButton'
export default IconButton
